export default "__VITE_ASSET__UiTlOMYe__"